Ext.define('SA.HistogramViewController', {
    constructor({modeState, model, toolbar, projectView, view}) {
        this.modeState = modeState;
        this.model = model;
        this.toolbar = toolbar;
        this.projectView = projectView;
        this.view = view;

        this.proxy = new SA.HistogramProxy();

        this.initEvents();
    },

    initEvents() {
        this.modeState.onActive(this.refresh, this);

        this.stateObserver = new SA.HistogramViewStateObserver({
            targets: {model: this.model, proxy: this.proxy, projectView: this.projectView},
            handler: this.refresh,
            scope: this
        });

        this.toolbar.on('change:attribute', this.onAttributeDropdownChange, this);
        this.toolbar.on('change:unit', this.onGeoUnitDropdownChange, this);
        this.toolbar.on('change:location', this.onLocationDropdownChange, this);
        this.toolbar.on('click:viewActions:edit', this.onViewActionsEditClick, this);
        this.toolbar.on('click:viewActions:createDataTable', this.onViewActionsCreateDataTableClick, this);
        this.toolbar.on('click:viewActions:delete', this.onViewActionsDeleteClick, this);
        this.toolbar.on('activate:exportBtn', this.onExportBtnActivate, this);

        this.view.on('flush:chartTitle', this.onChartTitleFieldFlush, this);
        this.view.on('change:attribute', this.onAttributeDropdownChange, this);
        this.view.on('change:binSize', this.onBinSizeControlChange, this);
        this.view.on('change:barColor', this.onBarColorButtonChange, this);
    },

    getView() {
        return this.view;
    },

    onAttributeDropdownChange(attribute) {
        this.model.setData({attribute});
    },

    onBarColorButtonChange(barColor) {
        this.model.setData({barColor});
    },

    onBinSizeControlChange(binSize) {
        this.model.setData({binSize});
    },

    onChartTitleFieldFlush(chartTitle) {
        this.model.setData({title: chartTitle});
    },

    onExportBtnActivate(btn) {
        var modelState = this.state.model,
            resultPromise = this.state.request.getResultPromise();

        new SA.HistogramExportController({toolbarButton: btn, modelState, resultPromise});
    },

    onGeoUnitDropdownChange(geographicUnit) {
        this.model.setData({geographicUnit});
    },

    onLocationDropdownChange(location) {
        this.model.setData({location});
    },

    onViewActionsCreateDataTableClick() {
        var locations = this.model.getLocations(),
            geographicUnit = this.model.getGeoUnit(),
            attributes = this.model.getAttributes(),
            censusRelease = this.model.getCensusRelease(),
            ranking = this.model.getProject().addViewWithParams({type: 'ranking', params: {locations, geographicUnit, attributes, censusRelease}});

        SA.AppController.showProjectView(ranking);
    },

    onViewActionsDeleteClick() {
        SA.AppController.deleteView(this.model);
    },

    onViewActionsEditClick() {
        SA.AppController.showProjectView(this.model, 'edit');
    },

    refresh() {
        if (!this.modeState.isActive()) {
            return;
        }

        var modelState = this.model.getState(),
            availableSpace = this.projectView.getSize(),
            request = this.proxy.getRequest(modelState),
            firstResultPending = this.proxy.isFirstResultPending();

        this.state = new SA.HistogramViewState({modelState, availableSpace, request, firstResultPending});
        this.toolbar.setState(modelState);
        this.view.setState(this.state);
    }
});